module.exports = __webpack_public_path__ + "static/51import-24901f20468dbbd22259f545a87f4943.png";